import { useTranslation } from 'react-i18next';
import { formatCr } from '@/lib/cr';

interface CrAmountProps {
  /** USD decimal 字符串或数字(CR 只在展示层换算) */
  usd: string | number;
  className?: string;
}

/** 全站 CR 金额渲染组件:formatCr + " CR",随 i18n locale 切换数字格式。 */
export function CrAmount({ usd, className }: CrAmountProps) {
  const { i18n } = useTranslation();
  return (
    <span className={className}>{formatCr(usd, { locale: i18n.language })} CR</span>
  );
}
